<div class="inhalativ-oral-block {{partnerName}}">
    <div class="block">
        <div class="block-title" [class.active]="activeBlock==='INHALATIV'">Inhalativ</div>
        <div class="block-section">
            <div class="block-image">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">
                        <img src="/images/private/avextra/Inhalativ Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ALTHEA">
                        <img src="/images/private/althea/Inhalativ Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.BETAHEALTH">
                        <img src="/images/private/betahealth/Inhalativ Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.FOUR_20_PHARMA">
                        <img src="/images/private/420pharma/Inhalativ Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <img src="/images/medizinisches/Inhalativ Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                </ng-container>
            </div>
            <div class="block-buttons">
                <ng-container *ngFor="let item of inhalativOptions">
                    <button type="button" class="input-button" [class.selected]="selectedOption.Label===item.Label" (click)="selectOption(item)">
                        <span>
                            {{item.Label}}
                            <ng-container *ngIf="item.Code"> {{item.Code}}</ng-container>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="block">
        <div class="block-title" [class.active]="activeBlock==='ORAL'">Oral</div>
        <div class="block-section">
            <div class="block-image">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">
                        <img src="/images/private/avextra/Oral Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ALTHEA">
                        <img src="/images/private/althea/Oral Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.BETAHEALTH">
                        <img src="/images/private/betahealth/Oral Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.FOUR_20_PHARMA">
                        <img src="/images/private/420pharma/Oral Graph.svg" alt="Inhalativ Graph.svg" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <img src="/images/medizinisches/Oral Graph.svg" alt="Oral Graph.svg" />
                    </ng-container>
                </ng-container>
            </div>
            <div class="block-buttons">
                <ng-container *ngFor="let item of oralOptions">
                    <button type="button" class="input-button" [class.selected]="selectedOption.Label===item.Label" (click)="selectOption(item)">
                        <span>
                            {{item.Label}}
                            <ng-container *ngIf="item.Code"> {{item.Code}}</ng-container>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
